import React from 'react';
import './Footer.css';

const Footer = () => {
  console.log("Footer render", Date.now());
  return (
    <footer className="footer">
      <p>&copy; 2024 Confident Group</p>
      <img 
        src={`${process.env.PUBLIC_URL}/assets/logo.png`} 
        alt="Confident Group Logo" 
        className="footer-logo" 
      />
    </footer>
  );
};

export default Footer;